<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>

      <div class="main-div">
        <el-container class="main-div parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
              <!--SID1004 Body Part-->
              <template>
                <el-container class="SID1004__infoRegistration">
                  <div class="SID1004__Container">
                    <!-- Breadcrumb section -->
                    <el-breadcrumb separator-class="el-icon-arrow-right customStyle">
                      <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '' }">テーマグループ一覧</el-breadcrumb-item>
                    </el-breadcrumb>
                    <!-- Breadcrumb section Ended -->
                    <div class="button-div">
                      <el-button class="buttonTable" @click="toppage()" type="info" plain>戻る</el-button>
                    </div>

                    <el-container>
                      <el-tabs v-model="getactivename" @tab-click="handleClick">
                        <el-tab-pane label="新規作成・編集" name="first" >
                          <div class="ButtonDiv">
                            <el-button type="primary" plain @click="newTheme()">追加</el-button>
                            <el-button type="danger" @click="deleteFromTheTable" plain>削除</el-button>
                          </div>
                          <div>
                            <el-table
                              :data="getTableResult1004_1"
                              border
                              style="width: 100%"
                              @selection-change="handleSelectionChange"
                              class="first_table"
                              ref="multipleTable"
                            >
                              <el-table-column
                                type="selection"
                                class="messageCheckbox"
                                v-model="Selected"
                                width="60"
                              ></el-table-column>
                              <el-table-column label="編集" fixed width="100">
                                <template slot-scope="scope">
                                  <el-button
                                    type="primary"
                                    plain
                                    @click="editCurrentRow(scope.row)"
                                  >編集</el-button>
                                </template>
                              </el-table-column>
                              <el-table-column v-if="themeId" prop="theme_group_id" label></el-table-column>
                              <el-table-column  prop="" type="index" label="表示順" width="100"></el-table-column>
                              <!-- 2022/09/29 No14.テーマ等IDの画面表示  START-->
                              <!-- <el-table-column
                                  prop="theme_group_name"
                                  label="テーマグループ名"
                                  min-width="350"
                                ></el-table-column>-->
                              <el-table-column
                                  prop="theme_group_name"
                                  label="テーマグループ名"
                                  min-width="350"
                              >
                                <template slot-scope="scope">
                                  TG{{scope.row.theme_group_id}}: {{scope.row.theme_group_name}}
                                </template>
                              </el-table-column>
                              <!-- 2022/09/29 No14.テーマ等IDの画面表示  END-->
                              <el-table-column prop="user_group_count" label="ユーザーグループ数"></el-table-column>
                              <el-table-column prop="theme_count" label="テーマ数"></el-table-column>
                            </el-table>
                          </div>

                          <div class="ButtonDivTable">
                            <el-button type="primary" plain @click="newTheme()">追加</el-button>
                            <el-button type="danger" plain @click="deleteFromTheTable">削除</el-button>
                            <span class="buttonSpan">{{ text }}</span>
                          </div>
                        </el-tab-pane>
                        <el-tab-pane label="表示順指定" name="second">
                          <div class="ButtonDivTable">
                            <el-button type="primary"  @click="dragTableClick()" plain>保存</el-button>
                            <div class="secondTab">
                              <span>テーマグループをドラッグして表示順を設定してください</span>
                            </div>
                          </div>
                          <div>
                            <el-table-draggable>
                              <el-table
                                border
                                ref="orderTable"
                                :data="getTableResult1004"
                                style="width: 100%"
                                class="secondtableClass"
                              >
                                <el-table-column label width="90">
                                  <img
                                    class="table-img"
                                    src="../../assets/image/two_lines-svg.svg"
                                    alt="LOGO"
                                  />
                                </el-table-column>
                               
                                <el-table-column  label="表示順" type="index" width="160"></el-table-column>
                                <!-- 2022/09/29 No14.テーマ等IDの画面表示  START-->
                                <!-- <el-table-column
                                  property="theme_group_name"
                                  label="テーマグループ名"
                                  width="230"
                                ></el-table-column>-->
                                <el-table-column
                                    prop="theme_group_name"
                                    label="テーマグループ名"
                                    min-width="230"
                                >
                                  <template slot-scope="scope">
                                    TG{{scope.row.theme_group_id}}: {{scope.row.theme_group_name}}
                                  </template>
                                </el-table-column>
                                <!-- 2022/09/29 No14.テーマ等IDの画面表示  END-->
                                <el-table-column property="user_group_count" label="ユーザーグループ数"></el-table-column>
                                <el-table-column property="theme_count" label="テーマ数"></el-table-column>
                              </el-table>
                            </el-table-draggable>
                          </div>
                          <div class="BottomButtonDivTable">
                             
                            <el-button
                              class="setMarginTop"
                              type="primary"
                              style
                              plain
                              @click="dragTableClick()">保存</el-button>
                            <span class="buttonSpan">{{ dummy }}</span>
                          </div>
                          
                        </el-tab-pane>
                      </el-tabs>
                    </el-container>
                  </div>
                </el-container>
              </template>
              <!--SID1004 Body Part End-->
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>

      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>


<script>
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import ElTableDraggable from "element-ui-el-table-draggable";
import json from "../../components/config.json";
import common_json from "../../common/CommonConst.json";
const newArr = {};
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import router from "../../router";

export default {
  name: "app",
  props: {},
  components: {
    Header,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane,
    ElTableDraggable
  },
  data() {
    return {
      multipleSelection: [],
      text: "",
      dummy: "",
      Selected: [],
      themeId: false,
      contract_id:''
    };
  },
  methods: {
    //  Gets called when the user clicks on the 削除 button
    // Get all record to pass this delete function
    // checked is pass value "1"  that records are deleted.
    // unchecked is pass value "0" that records to be updated.
    deleteFromTheTable() {
          this.$LogButtonEvent("1004","Delete");
          this.$LogMethodIN("1004","deleteFromTheTable");
          var tableContent_final=[];
      if (this.$refs.multipleTable.selection.length > 0) {
        this.$confirm(json["1004_delete_confirm_message"],json["1004_delete_confirm_message_title"],{
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル"
            
          }).then(() => {
            var arraySelection = this.$refs.multipleTable.selection;
            var tableArray = this.$refs.multipleTable.tableData;
      
      
      for(var i=0;i< tableArray.length; i++){
        var tabledata_inner = {};
        tabledata_inner.theme_group_id = this.getThemeGroupResult1004[i];
        tabledata_inner.theme_check = 0;

        for(var k=0;k<arraySelection.length;k++){
          if(tableArray[i].theme_group_id == arraySelection[k].theme_group_id){
              tabledata_inner.theme_check = 1;
              
          }
        }
         tableContent_final.push(tabledata_inner);
      }

    // assign the details to "deleteDetails" varaible name
    var deleteDetails = {
        contract_id: this.contract_id,
        "theme_group_info":tableContent_final

        };

       // pass the parameters to the communicatio1004_1 page
        this.$store.dispatch("communication1004_1/tableDelete", deleteDetails);
          this.$alert(json["1004_delete_success_message"], json["1004_delete_success_title"], {
          confirmButtonText: 'OK',
          
        });
               
        })
      } else {
        this.$alert(
          json["1004_checkbox_not_check_message"],
          json["1004_checkbox_not_check_message_title"],
          {
            confirmButtonText: "OK"
          }
        );
      }
      this.$LogMethodOut("1004","deleteFromTheTable");  
    },
    //To get the checked checkbox
    handleSelectionChange(val) {
      newArr.value = val;
    },
    //call when the user going for new theme
    newTheme() {
      this.$LogButtonEvent("1004","Add");
      this.$LogMethodIN("1004","newTheme");
       common_json["redirect_path"] = "1005";
      router.push({name: "1005"});
       this.$LogMethodOut("1004","newTheme");
    },
    /**
     * Gets called when the user clicks on the 編集 button
     * parameters are theme_group_id,theme_group_name,user_group_count,theme_count
     */
    editCurrentRow(row) {
      this.$LogButtonEvent("1004","Edit");
      this.$LogMethodIN("1004","editCurrentRow");
      var Details = {
        theme_group_id: row.theme_group_id,
        theme_group_name: row.theme_group_name,
        user_group_count: row.user_group_count,
        theme_count: row.theme_count,
        theme_Checked_status:this.getUpdateTheme,
        user_Checked_status:this.getUpdateUser,
        browsingValue:''

      };

      var edit_data = {
				contract_id : this.contract_id,
				theme_group_id : row.theme_group_id
			}
		this.$store.dispatch('communication1005/EditFormDetails_1005',edit_data).then(() => {
      common_json["redirect_path"] = "1005";
        router.push({
          name: "1005",
          params: {
            Details: Details
          }
        });
      
    });
     

     this.$LogMethodOut("1004","editCurrentRow"); 
    },
    toppage() {
      this.$LogButtonEvent("1004","Return");
      this.$LogMethodIN("1004","toppage");
      common_json["redirect_path"] = "Home";
      router.push({
        name: "Home"
      });
      this.$LogMethodOut("1004","toppage");
    },
    //Get draggable data's with display_order and topics_id 
    // That information form array format send to the communication
    dragTableClick() {
      this.$LogButtonEvent("1004","Save");
      this.$LogMethodIN("1004","dragTableClick");
      var tableLoop = this.$refs.orderTable.tableData.length;
    
     var tableContent=[];
      for(var i=0;i<tableLoop;i++){
        
          var tableContent1={};
        
          tableContent1.theme_group_id=this.$refs.orderTable.tableData[i].theme_group_id;
          
            tableContent1.display_order=this.getDisplayOrderResult1004[i];
            tableContent.push(tableContent1);
          
      }
      var draggableOrderList ={
        contract_id:this.contract_id,
        theme_groups_info:tableContent
      
      }
   
     this.$store.dispatch("communication1004_1/draggableOrder",draggableOrderList);
      
      this.$alert(
        json["1004_2_success_message"],
        json["1004_2_success_title"],
        {
          confirmButtonText: "OK"
        }
      );
    this.$LogMethodOut("1004","dragTableClick");
    },
    handleClick: function(tab, event) {
      console.log(tab, event);     
    }
  },

  computed: {
    ...mapGetters("situation1004", [
      "getTableResult1004",
      "getcheck",
      "getactivename",
      "getUpdateTheme",
      "getUpdateUser",
      "getDisplayOrderResult1004",
    ]),
    ...mapGetters("situation1004_1", [
      "getTableResult1004_1",
      "getThemeGroupResult1004"
    ]),
		...mapGetters("situation0001", [     
			"getContractId"
		]),
  },
  //called after all the DOM elements has been mounted
  created () {
      //For the screen Title
     document.title = "テーマグループ一覧画面";
   
  },
  beforeCreate() {
    
    common_json["redirect_path"] = '1004';
  },
  mounted(){
    this.contract_id = this.getContractId
  //Get table articles during page load
  this.$store.dispatch("communication1004/getTableData");
  this.$store.dispatch("communication1004_1/getTableData");
  this.$store.dispatch("communication1004_1/getSampleTableData");
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
@import "1004.css";
</style>